/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2022, Zumper
 */

import { checkLoggedIn } from '@zcode-ui/web-zumper-global-state'
import * as Api from '@zcode/nr/es/shared/api'
import { logger } from '../../../logger'
import { receiveStreamChannels } from '../actions/index'

export const loadConversationPostLead =
  ({ buildingId, listingId, messageId }) =>
  async (dispatch, getState) => {
    if (!messageId || (!listingId && !buildingId)) {
      return
    }
    try {
      const response = await Api.conversationsPoll.get({
        ...(buildingId && { building_id: buildingId }),
        ...(listingId && { listing_id: listingId }),
        message_id: messageId,
      })
      if (!response) {
        return
      }
      const { invite_token: inviteToken, stream_channel_id: streamChannelId } = response
      if (inviteToken && checkLoggedIn(getState())) {
        try {
          await Api.claimConversation.post({ token: inviteToken })
        } catch (e) {
          logger.error(
            `Failed to claim stream conversation in loadConversationPostLead inviteToken=${inviteToken}, streamChannelId=${streamChannelId}`,
            e
          )
        }
      }
      if (!inviteToken) {
        // If the conversation hasn't been claimed, then we would need to include the inviteToken
        // in the "View Message" button href. We would also not be able to display the "View Message"
        // button once the user navigates away and returns (since we'll no longer have the streamChannelId
        // and inviteToken)
        // Product doesn't like the following experience, so we only show "View Message" to logged-in users
        // 1. User sends message
        // 2. User sees "View message" button
        // 3. User refreshes
        // 4. User sees "Message sent" instead of "View message"
        dispatch(
          receiveStreamChannels([
            { building_id: buildingId, listing_id: listingId, stream_channel_id: streamChannelId },
          ])
        )
      }
    } catch (e) {
      if (e.status === 204) {
        const retryAfter = e.headers.get('Retry-After')
          ? Number(e.headers.get('Retry-After'))
          : null
        if (typeof retryAfter === 'number' && !isNaN(retryAfter)) {
          setTimeout(() => {
            dispatch(loadConversationPostLead({ buildingId, listingId, messageId }))
          }, retryAfter * 1000)
        }
      } else if (e.status !== 410 && e.status !== 404) {
        // ignoring the case where errors are expected for non M3 leads
        logger.error(
          `Failed to poll for message conversation given listingId: ${listingId}, buildingId: ${buildingId}, messageId: ${messageId}`,
          e
        )
      }
    }
  }
